const state = {
  alert: {
    show: false,
    content: '',
  },
  confirm: {
    show: false,
    content: {
      message: '',
      confirmText: '',
      cancelText: '',
      action: () => { },
    },
  },
};

const mutations = {
  alert(_state, alert) {
    _state.alert = alert;
  },
  confirm(_state, confirm) {
    _state.confirm = confirm;
  },
};

const actions = {
  showAlert(store, content) {
    store.commit('alert', {
      show: true,
      content,
    });
  },

  closeAlert(store) {
    store.commit('alert', {
      show: false,
      content: '',
    });
  },

  showConfirm(store, content) {
    store.commit('confirm', {
      show: true,
      content,
    });
  },

  closeConfirm(store) {
    store.commit('confirm', {
      show: false,
      content: {
        message: '',
        confirmText: '',
        cancelText: '',
        action: () => { },
      },
    });
  },
};

export default {
  namespaced: true,

  state,
  mutations,
  actions,
};
